/* eslint-disable react-native/no-inline-styles */
import React, {useEffect, useState} from 'react';
import {View, StyleSheet} from 'react-native';
import Button from '../../../components/Button';
import Text from '../../../components/Text';
import DataTable from '../../../components/DataTable';
import Modal from '../../../components/Modal';
import Input from '../../../components/Input';
import MaterialIcon from '@expo/vector-icons/MaterialCommunityIcons';
import Ionicon from '@expo/vector-icons/Ionicons';
import {WorkOrderCost} from '../../../@types/WorkOrder';
import {
  Menu as PopupMenu,
  MenuOption,
  MenuOptions,
  MenuTrigger,
} from 'react-native-popup-menu';

const WorkOrderCostsTable = ({
  workOrdersCosts,
  addWorkOrderCost,
  editable = true,
  deleteWorkOrderCost,
  updateWorkOrderCost,
}) => {
  const [showModal, setShowModal] = useState(false);
  const initialWorkOrder: WorkOrderCost = {
    id: null,
    maintenanceId: null,
    materialUsed: null,
    materialCost: 0,
    laborHrs: 0,
    laborRate: 0,
    total: 0,
  };
  const [workOrder, setWorkOrder] = useState(initialWorkOrder);
  const [total, setTotal] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(-1);

  const [menuVisible, setMenuVisible] = useState(false);

  const hideModal = () => {
    setShowModal(false);
    setWorkOrder(initialWorkOrder);
  };

  const openEditModal = index => {
    setCurrentIndex(index);
    setEditMode(true);
    setWorkOrder(workOrdersCosts[index]);
    setShowModal(true);
  };

  useEffect(() => {
    let _subTotal =
      parseInt(workOrder.materialCost as string, 10) +
      parseInt(workOrder.laborHrs, 10) * parseInt(workOrder.laborRate, 10);
    setWorkOrder({...workOrder, total: _subTotal});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workOrder.materialCost, workOrder.laborHrs, workOrder.laborRate]);

  useEffect(() => {
    const _total = workOrdersCosts.reduce(
      (acc, item) => acc + parseInt(item.total, 10),
      0,
    );
    setTotal(_total);
  }, [workOrdersCosts]);

  return (
    <View style={{marginTop: 10}}>
      <View style={styles.row}>
        <Text style={styles.my2}>Work order costs</Text>
        {editable && (
          <Button
            style={{}}
            variant="outline"
            rightIcon={<MaterialIcon name="plus" size={20} />}
            onPress={() => setShowModal(true)}>
            Add
          </Button>
        )}
      </View>
      <DataTable style={{borderWidth: 1, marginTop: 10}}>
        <DataTable.Header style={{paddingHorizontal: 0}}>
          <DataTable.Title
            textStyle={{paddingLeft: 10}}
            style={styles.tableCell}>
            Material
          </DataTable.Title>
          <DataTable.Title
            textStyle={{paddingLeft: 10}}
            style={styles.tableCell}>
            Cost
          </DataTable.Title>
          <DataTable.Title
            textStyle={{paddingLeft: 10}}
            numberOfLines={2}
            style={styles.tableCell}>
            Labour rate
          </DataTable.Title>
          <DataTable.Title
            textStyle={{paddingLeft: 10}}
            style={styles.tableCell}>
            Hours
          </DataTable.Title>
          <DataTable.Title
            textStyle={{paddingLeft: 10}}
            style={styles.tableCell}>
            Subtotal
          </DataTable.Title>
          {editable && (
            <DataTable.Title textStyle={{paddingLeft: 10}}>
              Manage
            </DataTable.Title>
          )}
        </DataTable.Header>

        {workOrdersCosts.map((item, index) => (
          <DataTable.Row
            key={item.materialUsed + index}
            style={{
              paddingHorizontal: 0,
              borderWidth: 1,
              borderRightWidth: 0,
              borderLeftWidth: 0,
            }}>
            <DataTable.Cell
              textStyle={{paddingLeft: 10}}
              style={styles.tableCell}>
              {item.materialUsed}
            </DataTable.Cell>
            <DataTable.Cell
              textStyle={{paddingLeft: 10}}
              style={styles.tableCell}>
              {item.materialCost}
            </DataTable.Cell>
            <DataTable.Cell
              textStyle={{paddingLeft: 10}}
              style={styles.tableCell}>
              {item.laborRate}
            </DataTable.Cell>
            <DataTable.Cell
              textStyle={{paddingLeft: 10}}
              style={styles.tableCell}>
              {item.laborHrs}
            </DataTable.Cell>
            <DataTable.Cell
              textStyle={{paddingLeft: 10}}
              style={styles.tableCell}>
              {item.total}
            </DataTable.Cell>
            {editable && (
              <DataTable.Cell>
                <PopupMenu>
                  <MenuTrigger>
                    <View style={{paddingLeft: 10}}>
                      <Ionicon name="ellipsis-vertical" size={24} />
                    </View>
                  </MenuTrigger>
                  <MenuOptions>
                    <MenuOption onSelect={() => openEditModal(index)}>
                      <Text>Edit</Text>
                    </MenuOption>
                    <MenuOption onSelect={() => deleteWorkOrderCost(index)}>
                      <Text>Delete</Text>
                    </MenuOption>
                  </MenuOptions>
                </PopupMenu>
              </DataTable.Cell>
            )}
          </DataTable.Row>
        ))}
        <DataTable.Row
          style={{
            paddingHorizontal: 0,
            borderWidth: 1,
            borderRightWidth: 0,
            borderLeftWidth: 0,
          }}>
          <DataTable.Cell textStyle={{fontWeight: 'bold', paddingLeft: 10}}>
            Total
          </DataTable.Cell>
          <DataTable.Cell />
          <DataTable.Cell />
          {/* <DataTable.Cell /> */}
          {/* <DataTable.Cell /> */}
          {/* <DataTable.Cell /> */}
          {/* <DataTable.Cell /> */}
          <DataTable.Cell textStyle={{fontWeight: 'bold', paddingRight: 10}}>
            {total}
          </DataTable.Cell>
        </DataTable.Row>
      </DataTable>

      <Modal isOpen={showModal} onClose={hideModal}>
        <Modal.Content maxWidth="400px" size="sm">
          <Modal.CloseButton />
          <Modal.Header>
            {editMode ? 'Edit work order cost' : 'Add work order cost'}
          </Modal.Header>
          <Modal.Body>
            <View style={styles.row}>
              <View style={{flex: 1}}>
                <Text style={styles.my2}>Material used</Text>
                <Input
                  placeholder="Material used"
                  value={workOrder.materialUsed as string}
                  onChangeText={text => {
                    setWorkOrder({...workOrder, materialUsed: text});
                  }}
                />
              </View>
              <View style={{flex: 1}}>
                <Text style={styles.my2}>Material cost ($)</Text>
                <Input
                  placeholder="Material cost"
                  value={workOrder.materialCost as string}
                  onChangeText={text => {
                    setWorkOrder({...workOrder, materialCost: text});
                  }}
                  keyboardType="numeric"
                />
              </View>
            </View>
            <View style={styles.row}>
              <View style={{flex: 1}}>
                <Text style={styles.my2}>Labour rate ($ per hour)</Text>
                <Input
                  placeholder="Labour rate"
                  value={workOrder.laborRate as string}
                  onChangeText={text => {
                    setWorkOrder({...workOrder, laborRate: text});
                  }}
                  keyboardType="numeric"
                />
              </View>
              <View style={{flex: 1}}>
                <Text style={styles.my2}>Labour hours</Text>
                <Input
                  placeholder="Labour hours"
                  value={workOrder.laborHrs as string}
                  keyboardType="numeric"
                  onChangeText={text => {
                    setWorkOrder({...workOrder, laborHrs: text});
                  }}
                />
              </View>
            </View>

            <View>
              <Text style={styles.my2}>Subtotal</Text>
              <Input
                multiline
                placeholder="Subtotal"
                value={(workOrder.total as number).toString()}
                defaultValue={String(workOrder.total)}
                editable={false}
              />
            </View>
          </Modal.Body>
          <Modal.Footer>
            <Button.Group space={2}>
              <Button
                variant="ghost"
                colorScheme="blueGray"
                onPress={hideModal}>
                Cancel
              </Button>
              <Button
                onPress={() => {
                  editMode
                    ? updateWorkOrderCost(workOrder, currentIndex)
                    : addWorkOrderCost(workOrder);
                  hideModal();
                }}>
                Save
              </Button>
            </Button.Group>
          </Modal.Footer>
        </Modal.Content>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  my2: {
    marginVertical: 4,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    columnGap: 20,
  },
  tableCell: {
    borderRightWidth: 1,
  },
});

export default WorkOrderCostsTable;
